'use strict'
/**
 * qaBypass.js · LA PUERTA DEL ENTORNO QA RENDERIZADO (sin login).
 * ════════════════════════════════════════════════════════════════════════════
 * Permite renderizar la app de un perfil SEMBRADO sin sesión — SOLO en preview/
 * staging/dev. En la PROD pública es IMPOSIBLE de activar (defensa en profundidad):
 *
 *   (1) requiere el flag de build REACT_APP_QA_BYPASS === '1' (que NUNCA se setea
 *       en el build de producción de Vercel · solo en builds de QA locales/preview), Y
 *   (2) el hostname NO puede ser el de la prod pública (backstop · aunque el flag
 *       se colara en un build prod, el host lo bloquea).
 *
 * NO acuña tokens · NO toca el auth de prod · es un render de datos sembrados (fixture
 * del motor) en un entorno aislado. Datos de salud reales NUNCA se exponen aquí.
 */

// Hosts de producción pública donde el bypass DEBE estar muerto pase lo que pase.
const PROD_HOSTS = new Set(['app.primelab.app', 'www.primelab.app', 'primelab.app'])

export function qaBypassEnabled() {
  // (1) flag de build · ausente en prod
  if (process.env.REACT_APP_QA_BYPASS !== '1') return false
  // (2) backstop por hostname · jamás en la prod pública
  if (typeof window !== 'undefined' && window.location && PROD_HOSTS.has(window.location.hostname)) {
    return false
  }
  return true
}

export default qaBypassEnabled
